import queries from '@apis/queries';
import { GetNoticesParams, NoticeRow } from '@models/notice';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useNotices() {
  const [page, setPage] = useState<number>(0);
  const params: GetNoticesParams = {
    page, size: 10,
  };
  const [notices, setNotices] = useState<NoticeRow[]>([]);
  const { data, status } = useQuery(queries.notice.list(params));
  const fetchEnabled = !data || !data.page.isLast;
  const isLoading = status === 'pending';
  const isBlank = !isLoading && notices.length === 0;
  useEffect(() => {
    if (data) {
      if (data.page.isFirst) {
        setNotices(data.content);
      } else {
        setNotices((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  const fetchNext = () => {
    if (fetchEnabled && status === 'success') {
      setPage((prev) => prev + 1);
    }
  };
  return {
    notices, fetchNext, fetchEnabled, isLoading, isBlank,
  };
}

export default useNotices;
